module.exports = __webpack_public_path__ + "static/media/image_banner_shi.8b5b8155.png";